import { useQuery } from '@tanstack/react-query';
import { fetchTRSClusters } from 'API/TRSCluster/fetchTRSClusters';

/**
 * Simple hook for fetching TRS clusters data for dropdown selection
 * Used in Add Node page to select which cluster the node belongs to
 */
const useTRSClusters = () => {
    return useQuery({
        queryKey: ['TRSClusters-for-nodes'],
        queryFn: fetchTRSClusters,
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000, // 10 minutes
        retry: 2,
        refetchOnWindowFocus: false,
        enabled: true,
    });
};

export default useTRSClusters;
